import mixpanel from "mixpanel-browser";
import { useAppContext } from "../Context/AppContext";
import { Urls } from "../Urls";

export const useMixPanelForTracking = () => {
  const { transporterInfo, clientIp, userName, loggedInPhone } = useAppContext();
  const TrackMixPanel = ({
    ModuleName,
    ScreenName,
    Data = "None",
    Definition,
  }) => {
    mixpanel.track(Definition, {
      ApplicationName: `${Urls.appnamemixpanel}`,
      ModuleName: ModuleName,
      ScreenName: ScreenName,
      ClientIP: clientIp,
      Data: Data,
      TransporterName: transporterInfo?.transporter_name,
      TransporterId: transporterInfo?.transporter_id,
      userName: userName,
      phoneNo: loggedInPhone
    });
  };

  return { TrackMixPanel };
};
